module.exports = __webpack_public_path__ + "img/application.fd071147.png";